import { Text as Paragraph } from '@/components/Typography';

export const DescElement = ({ text, id }: { text: string; id: string; tag?: string }) => {
  return (
    <Paragraph data-test={[`${id}-text`]} className="hero-banner-description" tag="p" type="lg">
      {text}
    </Paragraph>
  );
};
